const CalendarioPrenotazioni = () => {
    return (
        <div>
            <h1>CalendarioPrenotazioni</h1>
        </div>
    )
}

export default CalendarioPrenotazioni